// figma 86192:880836; up to 240 with a long title (86198:872958)
export const POPOVER_WIDTH = 192
export const POPOVER_MAX_WIDTH = 240

// Gap between the popover and the color picker under it.
export const PICKER_OFFSET_Y = 6
